(function () {
  const DEBUG_MODE = false;

  if (DEBUG_MODE) console.log("[INFO] content-formatter-tabs.js loaded");
  document.addEventListener("DOMContentLoaded", initFormatter);
  window.addEventListener("load", initFormatter);

  function initFormatter() {
    addFormattingStyles();
    const allPanels = document.querySelectorAll(".product-tab--panel");
    if (DEBUG_MODE)
      console.log("[INFO] Found .product-tab--panel elements:", allPanels.length);
    allPanels.forEach(formatContent);
  }

  function formatContent(panel) {
    if (!panel || !panel.textContent.trim()) return;

    const panelId = panel.id || "";
    const tabButton = document.querySelector(
      `.product-tab--button[data-tab="${panelId}"]`
    );
    const sectionTitle = tabButton
      ? tabButton.textContent.trim().toUpperCase().replace(/['']/g, "")
      : "";

    let originalText = panel.textContent.trim();
    originalText = originalText.replace(/!(\s)/g, "!\n");

    const isWhatsInside = /WHAT(\W|_)?S INSIDE/i.test(sectionTitle);
    const hasKeyIngredients = /Key Ingredients:/i.test(originalText);
    const isFragrance =
      /FRAGRANCE/i.test(sectionTitle) ||
      /Fragrance-free|Scent|Aroma|Notes/i.test(originalText);
    const isHowToUse = /HOW TO USE/i.test(sectionTitle);
    const isIngredients = /^INGREDIENTS$/i.test(sectionTitle);

    if (panel.classList.contains("formatted")) {
      if (DEBUG_MODE) console.log("[INFO] Panel already formatted, skipping...");
      return;
    }

    // ── WHAT'S INSIDE ──────────────────────────────────────────────────
    if (isWhatsInside) {
      if (DEBUG_MODE) console.log('[INFO] Formatting "What\'s Inside" tab...');

      panel.innerHTML = "";
      const contentDiv = document.createElement("div");
      contentDiv.className = "formatted-content";

      let textForProcessing = originalText.replace(/<br\s*\/?>/gi, "\n");
      const paragraphBlocks = textForProcessing.split(/\n\s*\n/);

      const hasDescriptionBlocks =
        paragraphBlocks.length > 1 &&
        paragraphBlocks.some((block) => {
          const lines = block
            .split("\n")
            .map((l) => l.trim())
            .filter((l) => l.length > 0);
          return lines.length > 1;
        });

      if (hasDescriptionBlocks) {
        if (DEBUG_MODE)
          console.log("[DEBUG] Processing as product + description blocks");

        paragraphBlocks.forEach((block) => {
          const lines = block
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0);

          if (lines.length > 0) {
            const productLine = lines[0];

            if (
              /\d+(\.\d+)?\s*(oz|ml|g)\b/i.test(productLine) ||
              /cream|lotion|butter|soap|oil|serum|balm|mask/i.test(productLine)
            ) {
              const productDiv = document.createElement("div");
              productDiv.className = "whats-inside-product";

              const productNameP = document.createElement("p");
              productNameP.className = "whats-inside-line";

              const check = document.createElement("span");
              check.className = "whats-inside-checkmark";
              check.innerHTML = "✓";

              const span = document.createElement("span");
              span.textContent = " " + productLine;

              productNameP.appendChild(check);
              productNameP.appendChild(span);
              productDiv.appendChild(productNameP);

              if (lines.length > 1) {
                const description = lines.slice(1).join(" ");
                const descP = document.createElement("p");
                descP.className = "whats-inside-description";
                descP.textContent = description;
                productDiv.appendChild(descP);
              }

              contentDiv.appendChild(productDiv);
            }
          }
        });
      } else {
        if (DEBUG_MODE) console.log("[DEBUG] Processing as simple product list");

        const textWithLinebreaks = textForProcessing.replace(
          /\.(?=\s|$)/g,
          ".\n"
        );
        let items = textWithLinebreaks
          .split(/[\r\n]+|(?<=oz\.)\s*(?=[A-Z\d])|(?<=oz\.)$/)
          .map((i) => i.trim())
          .filter((i) => i.length > 0)
          .map((item) =>
            item
              .replace(/^\d+\.\s+/, "")
              .replace(/\s+/g, " ")
              .replace(/(\d+(?:\.\d+)?)\s*oz\./i, "$1 oz.")
          );

        const weightOnlyRe = /^\d*\.?\d+\s*oz\.$/i;
        const combinedItems = [];
        for (let k = 0; k < items.length; k++) {
          if (
            weightOnlyRe.test(items[k]) &&
            k + 1 < items.length &&
            !weightOnlyRe.test(items[k + 1])
          ) {
            combinedItems.push(`${items[k]} ${items[k + 1]}`);
            k++;
          } else {
            combinedItems.push(items[k]);
          }
        }

        combinedItems.forEach((item) => {
          const p = document.createElement("p");
          p.className = "whats-inside-line";

          const check = document.createElement("span");
          check.className = "whats-inside-checkmark";
          check.innerHTML = "✓";

          const span = document.createElement("span");
          span.textContent = " " + item;

          p.appendChild(check);
          p.appendChild(span);
          contentDiv.appendChild(p);
        });

        if (combinedItems.length >= 4) {
          contentDiv.classList.add("multi-column-layout");
        }
      }

      panel.appendChild(contentDiv);
      panel.classList.add("formatted");
      return;
    }

    // ── PRODUCT BENEFITS + KEY INGREDIENTS (explicit split) ─────────────
    if (sectionTitle === "PRODUCT BENEFITS" && hasKeyIngredients) {
      if (DEBUG_MODE)
        console.log("[INFO] Formatting benefits + ingredients...");

      const parts = originalText.split(/Key Ingredients:/i);
      const benefitsText = parts[0].trim();
      const ingredientsText = parts[1] ? parts[1].trim() : "";

      const contentDiv = document.createElement("div");
      contentDiv.className = "formatted-content";

      if (benefitsText) {
        let benefitLines = benefitsText
          .replace(/<br\s*\/?>/gi, "\n")
          .split(/[\n\r]+/)
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        if (benefitLines.length <= 1) {
          benefitLines = extractBenefitLines(benefitsText);
        }

        benefitLines.forEach((line) => {
          const benefitPara = document.createElement("p");
          benefitPara.className = "benefit-line";

          const checkmark = document.createElement("span");
          checkmark.className = "benefit-checkmark";
          checkmark.innerHTML = "✓";

          const textSpan = document.createElement("span");
          textSpan.textContent = " " + line;

          benefitPara.appendChild(checkmark);
          benefitPara.appendChild(textSpan);
          contentDiv.appendChild(benefitPara);
        });

        if (benefitLines.length >= 4) {
          contentDiv.classList.add("multi-column-layout");
        }
      }

      const ingredientsDiv = document.createElement("div");
      ingredientsDiv.className = "ingredients-content";

      const header = document.createElement("h4");
      header.className = "ingredients-header";
      header.textContent = "Key Ingredients";
      ingredientsDiv.appendChild(header);

      if (ingredientsText) {
        let descriptionText = "";
        let packagingText = "";
        let remainingIng = ingredientsText.replace(/<br\s*\/?>/gi, "\n");

        if (/Packaged in/i.test(remainingIng)) {
          const packagingMatch = remainingIng.match(/Packaged in[^.]*\./i);
          if (packagingMatch) {
            packagingText = packagingMatch[0];
            remainingIng = remainingIng.replace(packagingMatch[0], "").trim();
          }
        }

        const descriptionPatterns = [
          /Goat milk, loaded/i,
          /loaded with/i,
          /rich in/i,
          /helps to/i,
          /preserves your/i,
          /maintains/i,
          /supports/i,
          /nourishes/i,
          /hydrates/i,
          /soothes/i,
        ];

        let descriptionStart = -1;
        for (const pattern of descriptionPatterns) {
          const matchPos = remainingIng.search(pattern);
          if (matchPos > -1) {
            descriptionStart = matchPos;
            break;
          }
        }

        let ingredientsList = [];
        if (descriptionStart > -1) {
          descriptionText = remainingIng.substring(descriptionStart).trim();
          remainingIng = remainingIng.substring(0, descriptionStart).trim();
        }

        ingredientsList = remainingIng
          .split(/[,&;\-\n\r]+/)
          .map((i) => i.trim())
          .filter(
            (i) =>
              i.length > 0 &&
              !/loaded with|rich in|helps to|preserves|maintains|supports|nourishes|hydrates|soothes/i.test(i)
          );

        ingredientsList.forEach((item) => {
          const p = document.createElement("p");
          p.className = "ingredient-line";

          const bullet = document.createElement("span");
          bullet.className = "ingredient-checkmark";
          bullet.innerHTML = "✓";

          const txt = document.createElement("span");
          txt.textContent = " " + item;

          p.appendChild(bullet);
          p.appendChild(txt);
          ingredientsDiv.appendChild(p);
        });

        if (descriptionText) {
          const descPara = document.createElement("p");
          descPara.className = "description-text";
          descPara.textContent = descriptionText;
          ingredientsDiv.appendChild(descPara);
        }

        if (packagingText) {
          const pkgPara = document.createElement("p");
          pkgPara.className = "packaging-text";
          pkgPara.textContent = packagingText;
          ingredientsDiv.appendChild(pkgPara);
        }
      }

      panel.innerHTML = "";
      panel.appendChild(contentDiv);
      panel.appendChild(ingredientsDiv);
      panel.classList.add("formatted");
      return;
    }

    // ── ROUTE TO HANDLER ───────────────────────────────────────────────
    if (isFragrance) {
      handleFragrance(originalText, panel);
    } else if (isHowToUse) {
      handleHowToUse(originalText, panel);
    } else if (isIngredients) {
      handleIngredients(originalText, panel);
    } else {
      handleDefault(originalText, panel);
    }

    panel.classList.add("formatted");
  }

  // ── FRAGRANCE NOTES ────────────────────────────────────────────────
  function handleFragrance(originalText, panel) {
    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    const entries = originalText
      .split(/\n\s*\n/)
      .map((e) => e.trim())
      .filter((e) => e.length > 0);

    entries.forEach((entry) => {
      const rawLines = entry.split(/\n/g);

      rawLines.forEach((line) => {
        const trimmed = line.trim();

        if (trimmed === "") {
          const spacer = document.createElement("p");
          spacer.className = "fragrance-spacer";
          spacer.innerHTML = "&nbsp;";
          contentDiv.appendChild(spacer);
        } else {
          const para = document.createElement("p");
          para.className = "fragrance-paragraph";
          para.textContent = trimmed;
          contentDiv.appendChild(para);
        }
      });
    });

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
  }

  // ── HOW TO USE ─────────────────────────────────────────────────────
  function handleHowToUse(originalText, panel) {
    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    const header = document.createElement("h4");
    header.className = "directions-header";
    header.textContent = "Directions";
    contentDiv.appendChild(header);

    const rawLines = originalText.split(/\n/g);

    rawLines.forEach((line) => {
      const trimmed = line.trim();

      if (trimmed === "") {
        const spacer = document.createElement("p");
        spacer.className = "how-to-spacer";
        spacer.innerHTML = "&nbsp;";
        contentDiv.appendChild(spacer);
      } else {
        const para = document.createElement("p");
        para.className = "content-paragraph";
        para.textContent = trimmed;
        contentDiv.appendChild(para);
      }
    });

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
  }

  // ── INGREDIENTS (plain text, no icons) ──────────────────────────────
  function handleIngredients(originalText, panel) {
    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    const rawLines = originalText.replace(/<br\s*\/?>/gi, "\n").split(/\n/g);

    rawLines.forEach((line) => {
      const trimmed = line.trim();

      if (trimmed === "") {
        const spacer = document.createElement("p");
        spacer.className = "how-to-spacer";
        spacer.innerHTML = "&nbsp;";
        contentDiv.appendChild(spacer);
      } else {
        const para = document.createElement("p");
        para.className = "content-paragraph";
        para.textContent = trimmed;
        contentDiv.appendChild(para);
      }
    });

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
  }

  // ── DEFAULT (Features & Benefits, etc.) ────────────────────────────
  // Short lines (<=80 chars) get checkmarks in a grid.
  // Long lines render as prose paragraphs below the grid.
  function handleDefault(originalText, panel) {
    const PROSE_THRESHOLD = 80;

    const rawText = originalText.replace(/<br\s*\/?>/gi, "\n");
    const rawLines = rawText.split(/\n/g);

    const bulletLines = [];
    const proseLines = [];

    rawLines.forEach((line) => {
      const trimmed = line.trim();
      if (trimmed === "") return;

      if (trimmed.length <= PROSE_THRESHOLD) {
        bulletLines.push(trimmed);
      } else {
        proseLines.push(trimmed);
      }
    });

    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    bulletLines.forEach((line) => {
      const p = document.createElement("p");
      p.className = "benefit-line";

      const checkmark = document.createElement("span");
      checkmark.className = "benefit-checkmark";
      checkmark.innerHTML = "✓";

      const textSpan = document.createElement("span");
      textSpan.textContent = " " + line;

      p.appendChild(checkmark);
      p.appendChild(textSpan);
      contentDiv.appendChild(p);
    });

    if (bulletLines.length >= 4) {
      contentDiv.classList.add("multi-column-layout");
    }

    const proseDiv = document.createElement("div");
    proseDiv.className = "description-content";

    proseLines.forEach((line) => {
      const p = document.createElement("p");
      p.className = "benefit-line";

      const checkmark = document.createElement("span");
      checkmark.className = "benefit-checkmark";
      checkmark.innerHTML = "✓";

      const textSpan = document.createElement("span");
      textSpan.textContent = " " + line;

      p.appendChild(checkmark);
      p.appendChild(textSpan);
      proseDiv.appendChild(p);
    });

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
    if (proseLines.length > 0) {
      panel.appendChild(proseDiv);
    }
  }

  // ── EXTRACT BENEFIT LINES (fallback for PRODUCT BENEFITS + Key Ingredients path)
  function extractBenefitLines(text) {
    const commonBenefits = [
      /cruelty[\s\-]?free/i,
      /clean[\s\-]?ingredients/i,
      /paraben[\s\-]?free/i,
      /dermatologist[\s\-]?tested/i,
      /gentle\s+on\s+your\s+skin/i,
      /gentle\s+for\s+your\s+skin/i,
      /great\s+for\s+all\s+skin\s+types/i,
      /non[\s\-]?gmo/i,
      /vegan/i,
      /organic/i,
      /natural/i,
      /eco[\s\-]?friendly/i,
      /sustainable/i,
      /recyclable/i,
      /biodegradable/i,
      /sulfate[\s\-]?free/i,
      /phthalate[\s\-]?free/i,
      /gluten[\s\-]?free/i,
      /non[\s\-]?greasy/i,
      /gender\s+neutral/i,
      /made\s+in\s+the\s+usa/i,
      /made\s+with\s+goat\s+milk/i,
    ];

    let foundBenefits = [];
    let remainingText = text;

    commonBenefits.forEach((benefitRegex) => {
      const match = remainingText.match(benefitRegex);
      if (match) {
        foundBenefits.push(match[0]);
        remainingText = remainingText.replace(benefitRegex, "");
      }
    });

    if (foundBenefits.length > 0) return foundBenefits;

    const separators = /[;\-\n\r]+|(?<=!)\s*(?=[A-Z])/;
    if (separators.test(text)) {
      return text
        .split(separators)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    }

    const words = text.split(/\s+/);
    const benefits = [];
    let current = "";

    words.forEach((word) => {
      if (/^[A-Z]/.test(word) && current.length > 0) {
        benefits.push(current.trim());
        current = word;
      } else {
        current += (current ? " " : "") + word;
      }
    });
    if (current) benefits.push(current.trim());
    return benefits;
  }

  // ── STYLES ─────────────────────────────────────────────────────────
  function addFormattingStyles() {
    if (document.getElementById("content-formatter-styles")) return;

    const styleEl = document.createElement("style");
    styleEl.id = "content-formatter-styles";

    styleEl.textContent = `
      .product-tab--panel {
        padding: 0 0 15px !important;
      }
      .formatted-content {
        padding: 0 25px;
        text-align: left;
      }
      .ingredients-content {
        padding: 0 25px;
        text-align: left;
        margin-top: 20px;
      }
      .description-content {
        padding: 0 25px;
        text-align: left;
        margin-top: 16px;
      }

      .benefit-line,
      .whats-inside-line,
      .ingredient-line {
        margin: 4px 0;
        line-height: 1.4;
        display: flex;
        align-items: flex-start;
      }

      .whats-inside-product {
        margin-bottom: 12px;
      }
      .whats-inside-description {
        margin: 4px 0 0 28px;
        line-height: 1.4;
        color: #666;
        font-size: 0.9em;
      }

      .benefit-checkmark,
      .whats-inside-checkmark,
      .ingredient-checkmark {
        color: #b88b76 !important;
        font-weight: bold;
        flex-shrink: 0;
        margin-right: 8px;
        width: 20px;
        height: 20px;
        background-color: #F0EADC;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }

      .ingredients-header,
      .directions-header {
        margin: 12px 0 6px;
        line-height: 1.4;
        font-weight: 600;
        font-size: 1.1em;
        color: #333;
      }

      @media only screen and (max-width: 767px) {
        .ingredients-header,
        .directions-header {
          font-size: 1em;
          font-weight: 500;
          margin: 8px 0 4px;
          opacity: 0.9;
        }
      }

      .fragrance-paragraph {
        margin: 6px 0;
        line-height: 1.5;
      }
      .fragrance-spacer {
        margin: 8px 0;
        height: 8px;
      }

      .description-text {
        margin: 8px 0;
        line-height: 1.5;
      }
      .packaging-text {
        margin: 8px 0;
        line-height: 1.5;
        font-style: italic;
        opacity: 0.8;
      }
      .content-paragraph {
        margin: 6px 0;
        line-height: 1.5;
      }
      .how-to-spacer {
        margin: 8px 0;
        height: 8px;
      }

      .multi-column-layout {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }

      @media only screen and (min-width: 768px) and (max-width: 1199px) {
        .multi-column-layout {
          grid-template-columns: repeat(3, 1fr);
        }
        .product-tab--panel .formatted-content,
        .product-tab--panel .ingredients-content,
        .product-tab--panel .description-content {
          max-width: 600px;
          margin: 0 auto;
          text-align: left;
        }
        .product-tab--panel .formatted-content p,
        .product-tab--panel .ingredients-content p,
        .product-tab--panel .description-content p {
          text-align: left;
        }
      }

      @media only screen and (max-width: 767px) {
        .multi-column-layout {
          grid-template-columns: repeat(2, 1fr);
          gap: 8px;
        }
        .product-tab--panel .formatted-content,
        .product-tab--panel .ingredients-content,
        .product-tab--panel .description-content {
          max-width: 100%;
          padding: 0 15px;
        }
      }

      @media only screen and (max-width: 480px) {
        .multi-column-layout {
          grid-template-columns: repeat(2, 1fr);
          gap: 6px;
        }
        .product-tab--panel .formatted-content,
        .product-tab--panel .ingredients-content,
        .product-tab--panel .description-content {
          padding: 0 12px;
        }
      }
    `;
    document.head.appendChild(styleEl);
  }

  // ── TAB OBSERVER & MUTATION OBSERVER ───────────────────────────────
  function setupTabObserver() {
    const tabButtons = document.querySelectorAll(".product-tab--button");
    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const targetId = this.getAttribute("data-tab");
        if (targetId) {
          const targetPanel = document.getElementById(targetId);
          if (targetPanel && !targetPanel.classList.contains("formatted")) {
            formatContent(targetPanel);
          }
        }
      });
    });
  }

  function observePageChanges() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              if (
                node.classList &&
                node.classList.contains("product-tab--panel")
              ) {
                formatContent(node);
              }
              const panels = node.querySelectorAll(".product-tab--panel");
              if (panels.length > 0) {
                panels.forEach(formatContent);
              }
            }
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  setupTabObserver();
  observePageChanges();

  window.dionisMobileFormatter = {
    formatContent: formatContent,
    formatAllPanels: function () {
      document.querySelectorAll(".product-tab--panel").forEach(formatContent);
    },
  };
})();